import React, { useState } from 'react';
import ToggledActionsCardView from '../view/ToggledActionsCardView';

// const exampleData = [
//   {
//     onAction: action,
//     icon: CopyIcon,
//     tooltip: 'Duplicate reminder',
//     internalName: 'duplicate' // for data-testid
//   }
// ];

const ToggledActionsCardEngine = ({
  id,
  children,
  actionButtons,
  onDelete,
  isActive: isActiveProp = false,
  onToggleChange: onToggleChangeProp,
  disabled,
  disableToggle,
  hideToggle,
  onDisabledClicked,
  onDisabledToggleClicked,
  deleteDialogProps = {},
  ...actionsCardProps
}) => {
  const [isActive, setIsActive] = useState(isActiveProp);
  const [isDeleteSequenceStart, setDeleteSequenceStart] = useState(false);

  const onToggleChange = () => {
    setIsActive(!isActive);
    onToggleChangeProp && onToggleChangeProp();
  };

  const onWrapperClick = () => {
    if (disableToggle && onDisabledToggleClicked) {
      onDisabledToggleClicked();
    }
  };

  const onDeleteSequenceStart = () => {
    setDeleteSequenceStart(true);
  };

  const viewProps = {
    id,
    disabled,
    disableToggle,
    onDisabledClicked,
    hideToggle,
    isActive,
    onToggleChange,
    onWrapperClick,
    setIsActive,
    onDelete,
    actionButtons,
    isDeleteSequenceStart,
    onDeleteSequenceStart,
    deleteDialogProps,
    ...actionsCardProps
  };

  return (
    <ToggledActionsCardView {...viewProps}>{children}</ToggledActionsCardView>
  );
};

export default ToggledActionsCardEngine;
